"use strict";

// On-screen corner toast, ported from Krunker_v3.1.1/mod/notify.ts.
// ─────────────────────────────────────────────────────────
// A single fixed div in the top-right corner that slides in, holds,
// then slides back out via a 2s CSS animation. Re-triggered by
// re-applying the .anim class (with a forced reflow so the animation
// restarts even when the same message fires twice in a row).
//
// Self-contained: no engine dependency. Exposed as window.notify so
// any module (bhop.js, devConsole.js) can call it.
// ─────────────────────────────────────────────────────────

var notification = document.createElement("div");
var anim = document.createElement("style");

notification.style.cssText = [
  "position: absolute",
  "z-index: 9999",
  "top: 10px",
  "right: 10px",
  "transform: translateX(calc(100% + 20px))",
  "padding: 10px",
  "margin: 10px",
  "box-sizing: border-box",
  "border-radius: 5px",
  "background: #0005",
  "color: #fff"
].join(";");

anim.textContent = "\
  @keyframes krkNotifySlide {\
      0%, 100% {\
          transform: translateX(calc(100% + 20px));\
      }\
      10%, 90% {\
          transform: translateX(0);\
      }\
  }\
  .krkNotifyAnim {\
      animation: krkNotifySlide 2s forwards;\
  }\
";

// Defer append until <body> exists (this file may be required during
// bootstrap, before DOMContentLoaded).
function attach() {
  if (document.body) {
    document.body.appendChild(notification);
    document.body.appendChild(anim);
    return true;
  }
  return false;
}
if (!attach()) {
  document.addEventListener("DOMContentLoaded", attach, { once: true });
}

function notify(message) {
  notification.innerHTML = message;
  notification.className = "";
  // Force reflow so re-adding the class restarts the animation.
  void notification.offsetHeight;
  notification.className = "krkNotifyAnim";
}

window.notify = notify;

module.exports = notify;
